import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { MyTaskService } from '../myTask.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-MyTaskList',
  templateUrl: './myTaskList.component.html',
  styleUrls: ['./myTaskList.component.css']
})
export class MyTaskListComponent implements OnInit {

  userData: any;
  countriesKeyValue: any;
  userList: [any];
  itemChange: boolean = false;
  searchText: any;
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  deleteDataItem
  horizontalAction = true;
  emitData: any = {
    key: "",
    val: ""
  }
  subscription: Subscription;
  userSubscription: Subscription;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  public gridData: any[];

  //public gridData: any[] = products;

  public fields: any[] = [
    { 'field': 'displayName', 'title': 'Name', 'width': 100 },
    {
      'field': 'institution', 'title': 'Institutions', 'width': 250,
      "ngTemplate": (dataItem) => {
        var Institutions = ``;
        dataItem.facilities.forEach((element, index) => {
          if (index != 0) {
            Institutions += `,\n`;
          }
          Institutions += element.facilityName;
        });
        return Institutions;
      }
    },
    { 'field': 'userName', 'title': 'UserName', 'width': 200 },
    { 'field': 'email', 'title': 'E-mail', 'width': 300 },
    //{ 'field': 'role', 'title': 'Role', 'width': 200 },
    {
      'field': 'isActive', 'title': 'Status', 'width': 100,
      "ngTemplate": (dataItem) => {
        return (dataItem.isActive) ? `${this.layoutService.translateText('INSTITUTION_MANAGEMENT.ACTIVE')}` : `${this.layoutService.translateText('INSTITUTION_MANAGEMENT.IN_ACTIVE')}`;
      }
    }
  ];

  actionItems: any = [
    // { name: 'View', imgSrc: 'assets/img/svg/icon-view.svg', onClick: (dataItem) => { this.view(dataItem) } },
    // { name: 'Edit', imgSrc: 'assets/img/svg/icon-edit.svg', onClick: (dataItem) => { this.edit(dataItem) } },
    { name: 'Approve', imgSrc: 'assets/img/svg/Approved.svg', onClick: (dataItem) => { this.viewDetail(dataItem) } },
    // { name: 'Cancel', imgSrc: 'assets/img/svg/Not-Approved.svg', onClick: (dataItem) => { this.edit(dataItem) } }
  ];

  pageInfo = {
    items: 'users',
    itemsPerPageLabel: 'users per page'
  };


  constructor(
    private router: Router,
    public config: AppConfig,
    private modalService: BsModalService,
    private service: MyTaskService,
    public layoutService: PHBHPLayoutPackageService
  ) { }

  ngOnInit() {
    this.service.getCountriesKeyValuePair().subscribe((res: any) => {
      this.countriesKeyValue = res;
    });
    this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.getAllusers(this.userData.roleName.roleId)
    })

    if (this.config.userData) {
      this.userData = this.config.userData;
      this.onUserChanges();
    }

    this.userSubscription = this.config.userSubject.asObservable().subscribe((changelang) => {
      this.userData = this.config.userData;
      this.onUserChanges();
    })

  }

  onUserChanges() {
    if (this.userData && !this.itemChange) {
      this.itemChange = true;

      this.getAllusers(this.userData.roleName.roleId)
    }
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();

    if (this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  getAllusers(roleId) {
    this.layoutService.showLoader = true;
    this.service.getAllUsers(roleId).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.gridData = res;
      this.changeLangCommentPage();
    })
  }

  changeLangCommentPage() {
    // this.gridData.forEach((value, index) => {
    //   if (this.gridData[index].role.roleName)
    //     this.gridData[index].role.roleName = this.data.translatetext(value.role.roleName);
    // });
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  delete() {
    // this.service.deleteUser(this.deleteDataItem.user.userId).subscribe(((res: any) => {
    //   var data: any[] = JSON.parse(JSON.stringify(this.gridData));
    //   this.gridData = [];
    //   var index = data.findIndex(user => user.user.userId === this.deleteDataItem.user.userId);
    //   data.splice(index, 1);
    //   this.gridData = data;
    // }))
  }

  viewDetail(dataItem) {
    this.service.userDetails = dataItem;
    this.emitData = {};
    this.emitData.key = 'mytask/detail';
    //this.emitData.val = dataItem;
    this.onChildData(this.emitData);
  }

  edit(dataItem) {
    this.emitData = {};
    this.emitData.key = 'user/edit/' + dataItem.userId;
    //this.emitData.val = dataItem;
    this.onChildData(this.emitData);
  }

  addUser() {
    this.emitData = {};
    this.emitData.key = 'user/add';
    //this.emitData.val = dataItem;
    this.onChildData(this.emitData);
  }
  onChildData(event: any) {
    this.router.navigate([event.key]);
  }
}
